import PricingBreakdown from './PricingBreakdown';

export default PricingBreakdown;
